import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "icn-section-progressbar",
  templateUrl: "./section-progressbar.component.html",
  styleUrls: ["./section-progressbar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionProgressbarComponent {
  @Input() currentStep;
  @Input() headers: Array<string>;

  @Output() jumpStep = new EventEmitter<number>();

  constructor() {}

  calcWidth(index) {
    let width = 100 / this.headers.length;
    if (index === this.headers.length - 1) {
      return 100 - width * (this.headers.length - 1) + "%";
    }
    return width + "%";
  }
}
